import { useState } from "react";
import { toast } from "sonner";
import { uploadInlineFile } from "@/services/upload.service";

const MAX_BYTES = 10 * 1024 * 1024;

// Mirrors ALLOWED_MIME_TYPES in server/src/controllers/upload.controller.js.
export const ACCEPTED_FILE_TYPES = [
	"image/jpeg",
	"image/png",
	"image/webp",
	"image/gif",
	"application/pdf",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	"application/msword",
	"application/vnd.ms-excel",
	"text/plain",
	"application/zip",
	"application/x-zip-compressed",
].join(",");

// Uploads files and hands back markdown for each: images embed, other files link.
export function useInlineUpload(insert: (markdown: string) => void) {
	const [pending, setPending] = useState(0);

	async function upload(files: File[]) {
		for (const file of files) {
			if (file.size > MAX_BYTES) {
				toast.error(`${file.name} is larger than 10 MB.`);
				continue;
			}
			setPending((n) => n + 1);
			try {
				const { url, file_name, mime_type } = await uploadInlineFile(file);
				const bang = mime_type.startsWith("image/") ? "!" : "";
				insert(`${bang}[${file_name}](${url})\n`);
			} catch (error) {
				toast.error(
					error instanceof Error
						? error.message
						: `Failed to upload ${file.name}.`,
				);
			} finally {
				setPending((n) => n - 1);
			}
		}
	}

	return { upload, uploading: pending > 0 };
}
